import cryptoJS from 'crypto-js';
import UtagHelper from 'utilities/utagHelper';
import { recordPage, recordEvent, RELIABLE, PAGE_PRODUCT } from 'utilities/uTagging';
import { PATH_SESSION_TIMEOUT, PATH_SESSION_COUNT_DAWN } from 'constants/uTagConstants/paths';

const recordModalPage = ({ path, userProfile, productsDescription }) => {
    const userId = typeof userProfile.userId !== 'undefined' ? userProfile.userId : '';
    const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
    const identityMethod =
        typeof userProfile.identityMethod !== 'undefined' ? RELIABLE[userProfile.identityMethod] : '';

    const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
    recordPage(
        path,
        userProfile.recordId,
        userId,
        userProfile.product,
        productsDescription,
        userProfile.promoCode ? userProfile.promoCode : '',
        JointHolderInfo,
        identityMethod,
        '',
        userProfile.investmentType,
        {
            identificadorOnboarding: docNumberEncrypted,
        }
    );

    return path;
};

const recordSessionEvent = ({ userProfile, eventAction, eventTag }) => {
    const userId = typeof userProfile.userId !== 'undefined' ? userProfile.userId : '';
    const identityMethod =
        typeof userProfile.identityMethod !== 'undefined' ? RELIABLE[userProfile.identityMethod] : '';
    const { docNumber } = userProfile;
    const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
    recordEvent(
        PATH_SESSION_COUNT_DAWN,
        PAGE_PRODUCT,
        eventAction,
        eventTag,
        userProfile.recordId,
        userId,
        identityMethod,
        userProfile.investmentType,
        docNumberEncrypted
    );
};

export const doTagSessionTimeoutModalPage = (userProfile, productsDescription) => {
    return recordModalPage({
        path: PATH_SESSION_COUNT_DAWN,
        userProfile,
        productsDescription,
    });
};

export const doTagSessionExpiredModalPage = (userProfile, productsDescription) => {
    return recordModalPage({
        path: PATH_SESSION_TIMEOUT,
        userProfile,
        productsDescription,
    });
};

export const doTagSessionOverWrittenModalPage = (userProfile, productsDescription) => {
    return recordModalPage({
        path: PATH_SESSION_TIMEOUT,
        userProfile,
        productsDescription,
    });
};

export const doTagSignOutSessionEvent = userProfile => {
    recordSessionEvent({
        userProfile,
        eventAction: 'salir del onboarding',
        eventTag: 'salir del onboarding correcto',
    });
};

export const doTagExitSessionEvent = userProfile => {
    recordSessionEvent({
        userProfile,
        eventAction: 'salir del onboarding',
        eventTag: 'salir del onboarding correcto',
    });
};

export const doTagRenewSessionEvent = userProfile => {
    recordSessionEvent({
        userProfile,
        eventAction: 'renovar sesion',
        eventTag: 'renovar sesion correcto',
    });
};
